import React, { useEffect } from 'react';
import './Home.css';
import translations from '../locale/fi.json';
import { FaArrowRight, FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';
import { usePageMeta } from '../seo/usePageMeta';
import GoogleReviews from '../components/GoogleReviews';

function Home() {
    usePageMeta({
        title: 'Jalkojesi Tähden | Jalkojenhoitoa Kuusamossa',
        description: 'Ammattitaitoista jalkojenhoitoon Kuusamossa. Kotikäynnit, hoivakodit ja hoitola.',
        canonicalPath: '/',
        breadcrumbs: [
            { name: 'Etusivu', url: 'https://jalkojesitahden.fi/' }
        ]
    });

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                }
            });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="home-container">
            {/* Hero Section - Caring & Professional */}
            <header className="hero-section reveal">
                <div className="hero-content">
                    <h1>{translations.home.hero_title}</h1>
                    <p>{translations.home.hero_subtitle}</p>
                    <div className="hero-cta-group">
                        <a href="/yhteystiedot" className="btn-brand">
                            <FaCalendarAlt /> {translations.home.hero_cta}
                        </a>
                        <a href="/palvelut-ja-hinnasto" className="btn-outline-brand">
                            {translations.navbar.servicepricing} <FaArrowRight />
                        </a>
                    </div>
                </div>
                <div className="hero-decorations">
                    <svg className="leaf-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <path d="M50 0C50 0 80 30 80 60C80 90 50 100 50 100C50 100 20 90 20 60C20 30 50 0 50 0Z" fill="var(--brand-pink)" opacity="0.1" />
                    </svg>
                    <svg className="leaf-svg-2" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <path d="M50 0C50 0 80 30 80 60C80 90 50 100 50 100C50 100 20 90 20 60C20 30 50 0 50 0Z" fill="var(--brand-pink-dusty)" opacity="0.08" />
                    </svg>
                </div>
                <div className="hero-visual-soft">
                    <div className="soft-blob blob-1"></div>
                    <div className="soft-blob blob-2"></div>
                </div>
            </header>

            {/* Professional Info Section - Original Content */}
            <section className="professional-care reveal">
                <div className="section-container">
                    <div className="care-layout">
                        <div className="care-text">
                            <h2 className="care-title">{translations.home.blog_title1}</h2>
                            <p className="care-description">{translations.home.blog_text1}</p>
                            <ul className="care-features">
                                <li><FaCheckCircle className="care-icon" /> Perushoidot ja osahoidot</li>
                                <li><FaCheckCircle className="care-icon" /> Yksilölliset kotihoito-ohjeet</li>
                                <li><FaCheckCircle className="care-icon" /> Kotikäynnit Kuusamon alueella</li>
                            </ul>
                            <a href="/yhteystiedot" className="btn-outline-brand">Ota yhteyttä <FaArrowRight /></a>
                        </div>
                        <div className="care-about">
                            <div className="about-decoration">
                                <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="var(--brand-pink)" d="M44.7,-76.4C58.2,-69.2,70,-59.1,78.8,-46.5C87.6,-33.9,93.5,-18.9,92.4,-4.1C91.3,10.7,83.2,25.3,73.5,38.3C63.8,51.3,52.5,62.8,39.3,71.1C26,79.4,10.8,84.5,-4.4,92.1C-19.6,99.7,-34.7,109.8,-47.9,107.4C-61.1,105,-72.4,90.2,-80.4,75.1C-88.4,60,-93.1,44.7,-95,29.1C-96.9,13.5,-96.1,-2.4,-91.7,-17.1C-87.3,-31.8,-79.3,-45.3,-68.2,-54.7C-57.1,-64.1,-42.8,-69.4,-29.4,-76.7C-16,-84.1,-3.5,-93.4,10.2,-95.2C23.9,-97.1,31.2,-83.6,44.7,-76.4Z" transform="translate(100 100)" opacity="0.05" />
                                </svg>
                            </div>
                            <h3>{translations.home.blog_title2}</h3>
                            <p>Olen valmistunut OSAO:lta jalkojenhoidon osaamisalalta. Työni perustuu jalkaterveyttä edistävään jalkojenhoitoon ja niiden kokonaisvaltaiseen hyvinvointiin. Jokainen asiakas kohdataan yksilöllisesti ja kiireettömästi.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Google Reviews */}
            <div className="reveal">
                <GoogleReviews />
            </div>

        </div>
    );
}

export default Home;
